//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const DEFAULT_FORMAT = (value) => (value ? value : "N/A");

export default {
  name: "GeographyTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table,
  },
  mounted: function () { },
  data: function () {
    return {
      separator: "horizontal",
      filteredData: [],
      columns: [
        {
          name: "id",
          required: false,
          label: "#ID",
          align: "left",
          field: (row) => row.id,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "level-number",
          required: false,
          align: "left",
          label: "Nº Nível",
          field: (row) => calcDepth(row.id, this.data, row.id),
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "classification-level",
          required: false,
          align: "left",
          label: "Classificação Nível",
          field: (row) => row.name,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "classification-level-agregator",
          required: false,
          align: "left",
          label: "Classificação Nível Agregador",
          field: (row) => {
            let item = this.data.filter((i) => i.id === row.parent_id).pop();
            return item ? item.name : "N/A";
          },
          format: DEFAULT_FORMAT,
          sortable: false
        }
      ]
    }
  },
  methods: {
    fetchRowData: function (index) {
      let data = this.data[index];
      this.$emit("clicked-row", data);
    },
    renderRightSide: function (event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event);
    },
  },
};

function calcDepth(id, data, initialID) {
  const element = data[data.map((i) => (i.id)).indexOf(id)];
  if (element === undefined) {
    return 0;
  }
  if (element.parent_id === initialID) {
    return 0;
  }
  if (element.parent_id === null) {
    return 1;
  } else {
    return 1 + calcDepth(element.parent_id, data, initialID);
  }
}
